// 按需引入 ECharts 核心与所需组件，控制打包体积
import * as echarts from 'echarts/core';

// 引入需要的图表类型
import {
  BarChart,
  LineChart,
  PieChart,
  RadarChart,
  FunnelChart,
  GraphChart,
} from 'echarts/charts';

// 引入需要的组件
import {
  TitleComponent,
  TooltipComponent,
  GridComponent,
  LegendComponent,
  RadarComponent,
  GraphicComponent,
} from 'echarts/components';

// 引入渲染器
import { SVGRenderer } from 'echarts/renderers';

// 按需注册
echarts.use([
  BarChart,
  LineChart,
  PieChart,
  RadarChart,
  FunnelChart,
  GraphChart,
  TitleComponent,
  TooltipComponent,
  GridComponent,
  LegendComponent,
  RadarComponent,
  GraphicComponent,
  SVGRenderer,
]);

export default echarts;
